<script setup lang="ts">
    import ParsedMarkdown from '../ParsedMarkdown.vue';
    import { IChatMessage } from '@/js/services/api/chat/chat';
    import { computed } from 'vue';
    import { __ } from '@/js/stores/expressions';
    import { useNotifyParentOnUpdate } from '@/js/composables/useWidgetUpdated';
    import { XIcon } from '@lucide/vue';

    const props = defineProps<{
        message: IChatMessage;
        show: boolean;
        isLast: boolean;
    }>();

    defineEmits<{
        (e: 'close'): void;
    }>();

    const showReasoning = computed(() => props.show);

    if (props.isLast) {
        useNotifyParentOnUpdate(showReasoning);
    }

    const markdown = computed(() =>
        typeof props.message.reasoning === 'string' ? props.message.reasoning : ''
    );
</script>

<template>
    <div v-if="show" class="Chat-message__reasoning">
        <button
            :aria-label="__('close-modal')"
            class="absolute top-2 right-2 w-5 h-5 flex items-center justify-center cursor-pointer z-50"
            @click="$emit('close')"
        >
            <XIcon class="size-5" />
        </button>
        <div class="py-4 px-2 m-2 text-body">
            <ParsedMarkdown :markdown="markdown" />
        </div>
    </div>
</template>
